const ITEMS = [
  "17-Mile Drive Transfers",
  "SFO / OAK / SJC / MRY Airport Chauffeur",
  "Pebble Beach Golf Resorts",
  "Carmel Valley Wine Tours",
  "Private Jet Shuttles",
  "Concours d'Elegance Service",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-line bg-abyss py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-mono text-[11px] uppercase tracking-[0.35em] text-smoke/70">
              {item}
            </span>
            <span className="h-1 w-1 rotate-45 bg-champagne/50" />
          </span>
        ))}
      </div>
    </div>
  );
}
